import React from 'react';
import { PageTrackerWrapper } from '@teetsh/app/src/queries/user/track';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import { Compte } from './Compte';
import { NotationSystemsSettings } from './NotationSystems';
import ParrainageSettings from './Parrainage/Loadable';
import { ChangePassword } from './ChangePassword';
import Subscription from './Souscription/Loadable';
import { queryClient } from '@teetsh/app/src/queryClient';
import { Missing } from './Souscription/Cancel/CancelSteps/Missing';
import { ReasonLeave } from './Souscription/Cancel/CancelSteps/ReasonLeave';
import { Details } from './Souscription/Cancel/CancelSteps/Details';
import { loader as billingInfoLoader } from '@teetsh/app/src/queries/useBillingInfos';
import { Recap } from './Souscription/Cancel/CancelSteps/Recap';
import { Navigate, Outlet } from 'react-router-dom';
import { Contact } from './Contact';
import { UserSettingsComponent } from './Settings';
import Materials from './Materials';
import BOLabels from './BOLabels';
import { OtherTool } from './Souscription/Cancel/CancelSteps/OtherTool';
import { ApplicationVersion } from '@teetsh/app/src/containers/UserSettings/Compte/ApplicationVersion';
import SchoolSubscription from './SchoolSubscription/Loadable';
import BulletinOfficielPageWrapper from '@teetsh/app/src/containers/UserSettings/BulletinOfficielPage/Loadable';
import ListBo from '@teetsh/app/src/containers/UserSettings/BulletinOfficielPage/List/Loadable';
import BoElement from '@teetsh/app/src/containers/UserSettings/BulletinOfficielPage/Bo/Loadable';
import { Trash } from '@teetsh/app/src/containers/UserSettings/Trash';
import { AIUsagePage } from './AIUsage';
import { NewCustomFieldsSettings } from './NewCustomFieldsSettings';
import { RedirectAccountSettingsOrMobileMenu } from 'containers/UserSettings/RedirectToAccountSettingsOrMobileMenu';
import { HeaderComponent } from 'containers/Header';
import UserSettingsWrapper from 'containers/UserSettings/Loadable';
import { UserAddLicencesPage } from './SchoolSubscription/UserAddLicencesPage';

export const UserSettingsRoutes = {
  path: 'settings',
  element: (
    <>
      <HeaderComponent withSubHeader />
      <Outlet />
    </>
  ),
  children: [
    {
      index: true,
      element: <RedirectAccountSettingsOrMobileMenu />,
    },
    {
      path: '*',
      element: <UserSettingsWrapper />,
      children: [
        {
          path: 'account',
          element: (
            <PageTrackerWrapper title="Configuration - compte">
              <TwoColumnsCardSidebar.Container>
                <Compte />
                <ApplicationVersion />
              </TwoColumnsCardSidebar.Container>
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'notation-systems',
          element: (
            <PageTrackerWrapper title="Configuration - système de notations">
              <NotationSystemsSettings />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'parrainage',
          element: (
            <PageTrackerWrapper title="Configuration - parrainage">
              <TwoColumnsCardSidebar.Container>
                <ParrainageSettings />
              </TwoColumnsCardSidebar.Container>
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'change-password',
          element: (
            <PageTrackerWrapper title="Configuration - mot de passe">
              <TwoColumnsCardSidebar.Main i18nKey="userSettings:password.title">
                <ChangePassword />
              </TwoColumnsCardSidebar.Main>
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'subscription',
          element: <Subscription />,
          children: [
            {
              path: 'cancel',
              children: [
                {
                  path: 'missing',
                  element: <Missing />,
                },
                {
                  path: 'reason',
                  element: <ReasonLeave />,
                },
                {
                  path: 'other-tool',
                  element: <OtherTool />,
                },
                {
                  path: 'details',
                  element: <Details />,
                },
                {
                  path: 'recap',
                  loader: billingInfoLoader(queryClient),
                  element: <Recap />,
                },
                {
                  index: true,
                  element: <Navigate to="missing" />,
                },
              ],
            },
          ],
        },
        {
          path: 'usage',
          element: (
            <PageTrackerWrapper title="Usage page">
              <AIUsagePage />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'school-subscription',
          children: [
            {
              path: 'licenses',
              element: (
                <PageTrackerWrapper title="Licences page">
                  <SchoolSubscription />
                </PageTrackerWrapper>
              ),
            },
            {
              path: 'invoices',
              element: (
                <PageTrackerWrapper title="Invoices page">
                  <SchoolSubscription />
                </PageTrackerWrapper>
              ),
            },
            {
              path: 'addLicences',
              element: (
                <PageTrackerWrapper title="Ajouter des licences">
                  <UserAddLicencesPage />
                </PageTrackerWrapper>
              ),
            },
            {
              index: true,
              element: <Navigate to="licenses" />,
            },
          ],
        },
        {
          path: 'contact',
          element: (
            <PageTrackerWrapper title="Configuration - contact">
              <Contact />
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'trash/*',
          element: (
            <PageTrackerWrapper title="Configuration - corbeille">
              <TwoColumnsCardSidebar.Main i18nKey="userSettings:restore.title">
                <Trash />
              </TwoColumnsCardSidebar.Main>
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'custom-fields',
          element: (
            <PageTrackerWrapper title="Configuration - champs personnalisables">
              <TwoColumnsCardSidebar.Main i18nKey="userSettings:customFields.title">
                <NewCustomFieldsSettings />
              </TwoColumnsCardSidebar.Main>
            </PageTrackerWrapper>
          ),
        },
        {
          element: (
            <TwoColumnsCardSidebar.Main>
              <UserSettingsComponent />
            </TwoColumnsCardSidebar.Main>
          ),
          children: [
            {
              path: 'bo-editor',
              element: <BulletinOfficielPageWrapper />,
              children: [
                {
                  index: true,
                  element: (
                    <PageTrackerWrapper title="Référentiels - liste">
                      <ListBo />
                    </PageTrackerWrapper>
                  ),
                },
                {
                  path: ':boId',
                  element: (
                    <PageTrackerWrapper title="Référentiels - détail">
                      <BoElement />
                    </PageTrackerWrapper>
                  ),
                },
              ],
            },
            {
              path: 'materials',
              element: (
                <PageTrackerWrapper title="Configuration - matériel">
                  <TwoColumnsCardSidebar.Title i18nKey="userSettings:materials.title" />
                  <Materials />
                </PageTrackerWrapper>
              ),
            },
            {
              path: 'bo-labels',
              element: (
                <PageTrackerWrapper title="Configuration - libellés">
                  <TwoColumnsCardSidebar.Title i18nKey="userSettings:curriculumLabels.title" />
                  <BOLabels />
                </PageTrackerWrapper>
              ),
            },
          ],
        },
      ],
    },
  ],
};
